import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  StatementQueryParams,
  StatementAccountResponse,
} from '../../pages/admin-dashboard/account-statement/account-statement-veiw-list/account-statement-veiw-list.model';
import { PharmacyAutoCompleteParams } from '../../pages/admin-dashboard/cart-management/admin-cart.model';
import { AuthService } from '../auth-service';

@Injectable({
  providedIn: 'root',
})
export class AccountStatementListDetails {
  private http = inject(HttpClient);
  private authService = inject(AuthService);

  private readonly API = environment.pharmacyMgtApiUrl;
  private readonly AUTO_COMPLETE_ENDPOINT = `${this.API}/pharmacies/auto/complete`;
  private readonly STATEMENT_ENDPOINT = `${this.API}/invoices/pharmacies`;

  private getAuthHeaders(): HttpHeaders {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  getAutoCompletePharmacies(queryParams: PharmacyAutoCompleteParams): Observable<PharmacyAutoCompleteParams> {
    const headers = this.getAuthHeaders();
    let params = new HttpParams();

    if (queryParams.quickSearch) params = params.set('quickSearch', queryParams.quickSearch);
    if (queryParams.isApproved !== undefined) params = params.set('isApproved', queryParams.isApproved.toString());
    params = params.set('pageNum', (queryParams.pageNum ?? 0).toString());
    params = params.set('pageSize', (queryParams.pageSize ?? 25).toString());

    return this.http
      .get<PharmacyAutoCompleteParams>(this.AUTO_COMPLETE_ENDPOINT, { params, headers })
      .pipe(catchError(this.handleError));
  }

  getStatementAccount(pharmacyId: number, queryParams: StatementQueryParams): Observable<StatementAccountResponse> {
    const headers = this.getAuthHeaders();
    const params = this.buildStatementParams(queryParams);
    const url = `${this.STATEMENT_ENDPOINT}/${pharmacyId}/statement/account`;

    return this.http.get<StatementAccountResponse>(url, { params, headers }).pipe(
      tap((response) => console.log(`Retrieved ${response.list?.length ?? 0} of ${response.total} invoices`)),
      catchError(this.handleError),
    );
  }

  private buildStatementParams(queryParams: StatementQueryParams): HttpParams {
    let params = new HttpParams();

    if (queryParams.invoiceId) params = params.set('invoiceId', queryParams.invoiceId);
    if (queryParams.orderId) params = params.set('orderId', queryParams.orderId);
    if (queryParams.createdOnFrom) params = params.set('createdOnFrom', queryParams.createdOnFrom);
    if (queryParams.createdOnTo) params = params.set('createdOnTo', queryParams.createdOnTo);
    if (queryParams.totalPriceFrom !== null && queryParams.totalPriceFrom !== undefined) {
      params = params.set('totalPriceFrom', queryParams.totalPriceFrom.toString());
    }
    if (queryParams.totalPriceTo !== null && queryParams.totalPriceTo !== undefined) {
      params = params.set('totalPriceTo', queryParams.totalPriceTo.toString());
    }
    if (queryParams.orderBy) params = params.set('orderBy', queryParams.orderBy);
    if (queryParams.orderDir) params = params.set('orderDir', queryParams.orderDir);

    params = params.set('pageNum', (queryParams.pageNum ?? 0).toString());
    params = params.set('pageSize', (queryParams.pageSize ?? 25).toString());

    return params;
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    return throwError(() => error.error);
  }
}
